<template>
  <!-- 公司介绍 -->
  <b-row class="about-company">
    <div class="company-text">
      <p>
        <span>汇才汇能(北京)科技有限公司</span
        >成立于2018年，经营范围包括技术开发、技术推广、技术转让、技术咨询、技术服务；会议服务；
        承办展览展示活动；企业管理咨询；财务咨询；税务咨询；税务代理；人力资源服务（以营业执照为准）。
      </p>
      <p>
        <span>汇才汇能</span>作为
        <span>专业人才终身赋能、企业服务全程陪伴者</span
        >，借助先进的平台化管理工具进行终生赋能，根据人才各阶段的能力需求，提供高质量、个性化、有针对性的能力提升服务，
        在满足自身能力需要的同时，满足企业端不同行业、不同阶段的专业能力需求，实现企业与人才的双赢。
      </p>
      <p>
        <span>针对专业人才</span
        >：无论你是在校学生、应届毕业生，或是具备经验的专业人士、行业专家，还是企业中的中高级管理人员，
        都可以根据自身需要找到适合的能力提升路径，通过平台的人才画像、能力评价等工具
        为专业人才职业生涯中的各个重要阶段提供准确、全面、高效的专业赋能，实现职业能力的有效提升。
      </p>
      <p>
        同时，针对专业人才特有的工作模式和时间安排，平台定向发送定制化的项目工作包，为在全职工作之余希望利用碎片化时间的专业人才提供能力输出机会，
        通过平台科学的项目分解、发包、承接、审核、结算、评价机制提供高频、稳定的自由职业机会，使专业人才在能力提升的同时，赚取“智慧之金”。
      </p>
      <p>
        <span>针对大中小企业</span
        >：企业发展的各个阶段对专业能力需求差异巨大，特别是在数字化转型的大背景下，内部专业人才很难满足企业各个阶段的能力需要。
        大中小企业有专业能力需求的部门可以通过平台将特定的能力或完整项目需求与有相应能力的人员进行匹配，及时、有效完成相应工作。
        同时，平台自有的资深智库团队亦可以协助企业对项目需求进行澄清，梳理、总结、分解项目的目标、实施路径和成果，
        并在必要的情况下对项目执行进行全程辅导，为企业提供全方位、一站式的专业能力输出服务。
      </p>
      <p>
        <span>针对中介猎头</span
        >：平台汇聚了大量专业人才，并且通过平台强大的人才画像功能和可靠的能力/技能认证功能已经进行了有效的识别和区分，
        可以为中介猎头和有专业人才招聘需求的企业人力部门提供更为精准、有效的人才匹配和专业人才储备库。
      </p>
      <p>
        <span>针对培训机构</span
        >：面对平台中海量的能力提升需求，培训机构可以提供基础、提升、转型、信息化、智能化等特色培训服务，借助平台多层次的课程管理系统，
        培训机构可以为处在不同阶段的专业人才提供更为有针对性和个性化的知识转移和赋能服务，更有效提升培训效果和价值。
      </p>
    </div>
  </b-row>
</template>
<script>
export default {};
</script>
